// extracted by mini-css-extract-plugin
export default {"formGroup":"_28OX","label":"_4gn8","input":"_2fu4"};